import {ScanRepository, CreateAssignmentRequest} from '../repositories/ScanRepository';

export class CreateAssignmentUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(request: CreateAssignmentRequest): Promise<{id: number}> {
    return await this.scanRepository.createAssignment(request);
  }
}
